"use client";

import { useEffect, useState } from "react";

const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState<boolean>();
  useEffect(() => {
    if (!!typeof window) {
      const mediaQueryList = window.matchMedia(query);
      const handleResize = () => {
        setMatches(mediaQueryList.matches);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [query]);
  return matches;
};

export default useMediaQuery;
